import React, { Component } from 'react';
import {connect} from 'react-redux'
import PropTypes from "prop-types";
import { fetchCheck } from '../../routers/settings'
import UrlApi from '../../lib/urlApi'

import FirstHeader from '../components/firstHeader'
import Header from '../components/header'
import HeaderNav from '../components/headerNav'
import Footer from '../components/footer'
import { getFinish } from '../../lib/ApiServices'
import { removeTemporalDetails } from '../../lib/ApiServices'


import { Link } from 'react-router-dom'


const slug = {
  es: ['aviso-legal', 'condiciones-del-servicio', 'politica-de-privacidad', 'politica-de-cookies'],
  fr: ['avis-juridique', 'conditions-d-utilisation', 'politique-de-confidentialite', 'politique-de-cookies']

}

const onClickPrint = (ref) => {
  window.open(`${UrlApi}/order/pdf/${ref}`);
}

const onClickDownload = (ref) => {
  window.location = `${UrlApi}/order/pdf/${ref}?download=true`;
}


const Valid = ({langPlace, reference}) => {
  const lang = window.location.pathname.split('/')[1]
  return (
    <div className="row" style={{minHeight: 490}}>
      <div className="container">
        <div className="flex-row ">
            <div className='col-md-12 col-sm-12 col-xs-12'>
              <div className='row section-middle-paragraph margin-top-50'>
                  {langPlace.info}
              </div>
              <div className='row separating-line'><hr/></div>
              <div className='row confirmation-code'>
                <i className="fa fa-credit-card" aria-hidden="true"></i>{`${langPlace.reservation}: ${reference.toUpperCase()}`}
              </div>
              <div className='row section-middle-paragraph'>
                {langPlace.message}
              </div>
              <div className='row separating-line'><hr/></div>
              <div className='row'>
                <div className='display-flex-end '>
                  <div className='general-button button-normal' onClick={() => onClickPrint(reference)}>
                    {langPlace.buttonprint}<i className="fa fa-print" aria-hidden="true"></i>
                  </div>
                  <div className='general-button button-normal' onClick={() => onClickDownload(reference)}>
                    {langPlace.buttondownload}<i className="fa fa-download" aria-hidden="true"></i>
                  </div>
                </div>
              </div>
              <div className='row section-middle-paragraph'>
              <Link to={`/${lang}/${slug[lang][1]}`}>{langPlace.condition}</Link>
              </div>
              <div className='row separating-line'><hr/></div>
            </div>
        </div>
      </div>
    </div>
  )
}

const Error = ({langPlace}) => {
  return (
    <div className="row" style={{minHeight: 490}}>
      <div className="container">
        <div className="flex-row ">
            <div className='col-md-12 col-sm-12 col-xs-12'>
              <div className='row confirmation-code margin-top-50'>
                <i className="fa fa-exclamation-triangle" aria-hidden="true"></i>{langPlace.errorTitle}
                <div className='row separating-line'><hr/></div>
                <i className="fa fa-phone" aria-hidden="true"></i>{langPlace.errormessange}
              </div>
            </div>
        </div>
      </div>
    </div>
  )
}


class routeConfirmation extends Component {
  static contextTypes = {
    router: PropTypes.object
  }

  componentDidMount() {
    const obj = this.createJson(this.context.router.route.location.search.replace('?','').split('&'))
    const reference = obj.reference

    this.props.fetchCheck(reference)
  }

  createJson = (array) => {
    let obj = {}
    for (let i in array) {
      let val = array[i].split('=')
      if (val.length === 2) {
        obj[val[0]] = val[1]
      }
    }

    return obj
  }

  render() {
    const langUrl = this.context.router.route.location.pathname.split('/')[1]
    const { languages } = this.props.settings
    const langPlace = languages[langUrl].confirmation
    console.log('langPlace'+langPlace)
    const obj = this.createJson(this.context.router.route.location.search.replace('?','').split('&'))
    const reference = obj.reference

    const response = this.props.data.response
    const error = (this.props.messages.error !== undefined)? this.props.messages.error: false

    return (
      <div>
        <FirstHeader />
        <Header />
        <div className='container-fluid route-confirmation'>
          <div className="row second-header">
            <div className="container">
              <div className="flex-row">
                <HeaderNav step={3}/>
              </div>
            </div>
          </div>

          {(() => {
            if (response !== undefined) {
              if (!error && reference !== undefined) {
                return <Valid langPlace={langPlace} reference={reference} />
              } else {
                return <Error langPlace={langPlace} />
              }
            } else {
              if (error) {
                return <Error langPlace={langPlace} />
              } else {
                return <div style={{minHeight: 490}} />
              }
            }
          })()}

        </div>
        <Footer />
      </div>
    )
  }
}

export default connect(
  (state) => ({settings: state.settings, data: state.data, messages: state.messages}),
  {fetchCheck}
)(routeConfirmation)



// WEBPACK FOOTER //
// ./src/shared/routes/routeConfirmation/index.js